import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthorizationService } from '@pwc-bei/security';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { EAccessPlanVariable } from '../enum/access-plan-variable';
import { AuthenticationUtilsService } from '../services/authentication-utils.service';

@Injectable({
  providedIn: 'root',
})
export class AccessPlanGuard implements CanActivate, CanActivateChild {
  constructor(
    private authenticationUtilsService: AuthenticationUtilsService,
    private authorizationService: AuthorizationService,
    private router: Router,
    private logger: NGXLogger,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canProceed(next);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canProceed(next);
  }

  private canProceed(
    next: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
    | Promise<boolean> {
    if (
      !this.authenticationUtilsService.getAccessPlan(
        EAccessPlanVariable.IS_USER_PREMIUM,
      )
    ) {
      return of(true);
    }

    return of(false);
  }
}
